
import widgetsDataService from '../../services/widgetsDataService.js'

const widgetConverter = {
    async init() {
        await this.initParams();
        this.initDropdowns();
        this.initEvents();
    },

    async initParams() {
        const dataset = $('.rate-converter-widget').data();
        this.data = await widgetsDataService.fetchWidgetDataAsync('getConverterData', dataset.coinId, dataset.currency);
        this.selectedCrypto = dataset.coinId;
        this.selectedFiat = dataset.currency;
        $('.rate-converter-widget-left .rate-converter-widget-select .rate-converter-widget-select__value').html(this.data.symbol.value);
        $('.rate-converter-widget-right .rate-converter-widget-select .rate-converter-widget-select__value').html(dataset.currency.toUpperCase());
        this.leftInput = $('.rate-converter-widget-left input[type="text"]');
        this.rightInput = $('.rate-converter-widget-right input[type="text"]');
    },

    initDropdowns() {
        //crypto
        let cryptoOptionsHtml = '';
        let coins = this.data.topCoins.value;
        for (let i = 0; i < coins.length; i++) {

            cryptoOptionsHtml += `<div class="rate-converter-widget-select-option" data-option-id-value="${coins[i].coinId}" data-option-symbol-value="${coins[i].symbol}">${coins[i].symbol} <span>${coins[i].name}</span></div>`;
        }

        $('.rate-converter-widget-left .rate-converter-widget-select-options').html(cryptoOptionsHtml);

        //fiat
        let fiatOptionsHtml = '';
        let fiats = this.data.fiats.value;
        let keys = Object.keys(fiats);

        for (let i = 0; i < keys.length; i++) {
            fiatOptionsHtml += ` <div class="rate-converter-widget-select-option" data-option-fiat-value="${keys[i]}">${keys[i]} <span>${fiats[keys[i]]}</span></div>`;
        }

        $('.rate-converter-widget-right .rate-converter-widget-select-options').html(fiatOptionsHtml);
    },

    initEvents() {
        const that = this;

        that.leftInput.val("1");
        that.convertInput(that.leftInput, that.rightInput, 1);

        $('.rate-converter-widget-left input[type="text"], .rate-converter-widget-right input[type="text"]').on('change input', function () {
            const input = $(this);
            const output = input.closest('.rate-converter-widget').find('input[type="text"]').not(input);
            const side = input.closest('.rate-converter-widget-left').length ? 1 : 2;
            that.handleInputChange(input, output, side);
        });

        $('.rate-converter-widget-left .rate-converter-widget-select-option').on('click', function () {
            const dataset = $(this).data();
            $(this).closest('.rate-converter-widget-left').find('.rate-converter-widget-select__value').html(dataset.optionSymbolValue);
            that.selectedCrypto = dataset.optionIdValue;
            that.convertInput(that.leftInput, that.rightInput, 1);
        });

        $('.rate-converter-widget-right .rate-converter-widget-select-option').on('click', function () {
            const dataset = $(this).data();
            let fiat = dataset.optionFiatValue;
            $(this).closest('.rate-converter-widget-right').find('.rate-converter-widget-select__value').html(fiat.toUpperCase());
            that.selectedFiat = fiat;
            that.convertInput(that.leftInput, that.rightInput, 1);
        });

        that.leftInput.on('blur', function () {
            that.formatInputValue($(this), that.data.locale);
        });

        that.rightInput.on('blur', function () {
            that.formatInputValue($(this), that.data.locale);
        });

        $('.rate-converter-widget-select').on('click', function () {
            $(this).toggleClass('select-open');
        });

        $('.rate-converter-widget-center img').on('click', function () {
            $(this).closest('.rate-converter-widget').toggleClass('rate-converter-widget-inverse');
        });
    },

    formatInputValue(input) {
        const value = input.val();
        if (value !== "") {
            const unformattedValue = this.unformatNumber(value, this.data.locale);
            const formattedValue = this.formatNumber(unformattedValue, this.data.locale);
            input.val(formattedValue);
        }
    },

    unformatNumber(value) {
        let parts = new Intl.NumberFormat(this.locale).formatToParts(111111111.1);
        let group = parts.find(s => s.type === 'group').value;
        let decimal = parts.find(s => s.type === 'decimal').value;

        value = value
            .replace(new RegExp('\\' + group, 'g'), '')
            .replace(new RegExp('\\' + decimal, 'g'), '.');

        return parseFloat(value);
    },

    formatNumber(value) {
        let number = parseFloat(value);
        let formatter = new Intl.NumberFormat(this.locale, { style: 'decimal' });
        return formatter.format(number);
    },

    handleInputChange(input, output, side) {
        const cleanedValue = this.removeNonNumberCharacters(input);
        if (cleanedValue !== "") {
            input.val(cleanedValue);
            this.convertInput(input, output, side);
        } else {
            output.val('');
        }
    },

    removeNonNumberCharacters(input) {
        let value = input.val().toString();

        value = value.replace(/,/g, '.');
        value = value.replace(/\.{2,}/g, '.');

        let cleanedValue = value.replace(/[^0-9.]/g, '');

        let decimalCount = (cleanedValue.match(/\./g) || []).length;
        if (decimalCount > 1) {
            cleanedValue = cleanedValue.replace(/\.(?=.*\.)/g, '');
        }

        return cleanedValue;
    },

    convertInput(input, output, side) {
        const fromValue = parseFloat(input.val());
        
        if (isNaN(fromValue)) {
            return;
        }

        const convertedValue = this.convertValue(fromValue, side);
        output.val(this.formatNumber(convertedValue));
    },

    convertValue(inputPrice, side) {
        if (!this.data.coinsPrices.value) {
            console.error('Missing coinId conversion rate data');
            return;
        }
        if (!this.data.coinsPrices.value[this.selectedCrypto]) {
            console.error('Missing coinId conversion rate data for', this.selectedCrypto);
            return;
        }
        const convertPrice = this.data.coinsPrices.value[this.selectedCrypto][this.selectedFiat];
        return side === 1 ? inputPrice * convertPrice : inputPrice / convertPrice;
    },
}

export default widgetConverter;
